import { useContext } from "react";
import BreadCrumbs from "./BreadCrumbs";
import parse from "html-react-parser";
import About from "./About";
import {
  CommentsButton,
  Headline,
  AboutWrapper,
  HeaderWrapper,
  SharingWrapper,
  AboutInnerWrapper,
  DailyMotionWrapper,
} from "./Header.styled";
import VideoPlayer from "Components/VideoPlayer";
import ArticleImage from "../ArticleImage";
import ArticleSharing from "../ArticleSharing";
import CenterWrapper from "Components/CenterWrapper";
import TopBanner from "common/Layout/Adverts/TopBanner";
import ImageGallery from "../components/ImageGallery";
import SponsorImage from "./SponsorImage";
import { AdvertContext } from "common/context/Adverts";
import { addTypes } from "common/context/Adverts/Adverts";
import DailyMotion from "../components/DailyMotion";
import { articleTypes } from "../Context/ArticleContext";
import { ArticleContext } from "../Context";

const Header = () => {
  const { leaderboard } = useContext<addTypes>(AdvertContext);
  const { refactoredArticle, isHeroOverride } =
    useContext<articleTypes>(ArticleContext);
  const {
    title,
    type,
    isYoutube,
    lead,
    hero,
    isVideo,
    dailyMotion,
    hierarchy,
    // showComments,
  } = refactoredArticle;

  return (
    <HeaderWrapper
      gallery={hero?.data.bundle === "gallery"}
      isVideo={isVideo || dailyMotion}
    >
      <CenterWrapper>
        {leaderboard && <TopBanner type={type} />}
        <br />
        <BreadCrumbs hierarchy={hierarchy} />
        <Headline>{title}</Headline>
        <div style={{ textAlign: "left", marginBottom: "16px" }}>
          {lead && parse(lead)}
        </div>

        {/* {showComments && (
          <CommentsButton>
            <a href="#comments">Leave a comment</a>
          </CommentsButton>
        )} */}

        {type !== "Service" && (
          <>
            <AboutWrapper>
              <AboutInnerWrapper>
                <About />
              </AboutInnerWrapper>
              <SponsorImage type="desktop" />
              <SharingWrapper>
                <ArticleSharing />
              </SharingWrapper>
            </AboutWrapper>
            <SponsorImage type="mobile" />
          </>
        )}
        {type === "Commercial" && (
          <>
            {hero?.type === "dailymotion" && (
              <DailyMotionWrapper>
                <DailyMotion isHero={true} data={hero.data} />
              </DailyMotionWrapper>
            )}
            {hero?.type === "image" && (
              <ArticleImage type="commerical" image={hero.data} />
            )}
          </>
        )}
        {isVideo && <VideoPlayer hero={hero} />}
        {dailyMotion && (
          <DailyMotionWrapper>
            <DailyMotion data={hero.data} isHero={true} />
          </DailyMotionWrapper>
        )}
        {hero?.data.bundle === "gallery" && (
          <ImageGallery hero={true} data={hero.data} />
        )}
      </CenterWrapper>
    </HeaderWrapper>
  );
};

export default Header;
